module.exports = __webpack_public_path__ + "static/media/fileupload_framed.51ad4ca4.png";